<div class="flex justify-end items-center gap-2">
  @if (plot?.data?.length > 0 && traceOptions().length > 0) {
    <div class="inline-block">
      <p-multiSelect
        [options]="traceOptions()"
        [ngModel]="selectedTraceNames()"
        (onChange)="onTraceVisibilityChange($event.value)"
        [filter]="true"
        [showHeader]="true"
        [showToggleAll]="true"
        scrollHeight="400px"
        placeholder=" "
        appendTo="body"
        title="Filter traces"
        styleClass="trace-visibility-multiselect"
      >
        <ng-template pTemplate="selectedItems">
          <i class="pi pi-chart-line"></i>
        </ng-template>
        <ng-template pTemplate="dropdownicon">
          <span></span>
        </ng-template>
      </p-multiSelect>
    </div>
  }
  @if (plot?.data?.length > 0) {
    <p-button
      size="small"
      severity="secondary"
      [outlined]="true"
      title="Format Axis"
      (click)="expandFormatAxis()"
      icon="pi pi-chart-bar"
    ></p-button>
  }
</div>
@if (showFormatAxis()) {
  <app-xy-line-plot-axis-editor
    [plotState]="plotState()"
    [yMinIndex]="yMinIndex"
    [yMaxIndex]="yMaxIndex"
    [legendBelowPlot]="legendBelowPlot"
    (axisChanged)="onAxisChanged($event)"
    (tickChanged)="onTickChanged($event)"
    (reset)="resetFormatAxis()"
  ></app-xy-line-plot-axis-editor>
}

<div
  [style]="{ position: 'relative', height: plotHeight(), width: '100%' }"
  #plotElement
  class="plot"
  (mousemove)="onPlotMouseMove($event)"
  (contextmenu)="onPlotContextMenu($event)"
  (mouseenter)="setHoverState(true)"
  (mouseleave)="setHoverState(false)"
>
  <p-contextMenu #plotCm [model]="plotContextMenuItems()" appendTo="body"></p-contextMenu>
@if (plot?.data?.length > 0) {
  <plotly-plot
    (wheel)="onScroll($event)"
    (doubleClick)="resetFormatAxis()"
    (afterPlot)="afterPlot()"
    (relayout)="relayout($event)"
    [divId]="plotName"
    [data]="plot.data"
    [layout]="plot.layout"
    [config]="plot.config"
    [updateOnDataChange]="true"
    [useResizeHandler]="true"
    [style]="{ position: 'relative', width: '100%', height: '100%' }"
  ></plotly-plot>
  }
  @if (showScrollOverlay()){
    <div class="absolute inset-0 flex items-center justify-center bg-black/40 pointer-events-none">
      <div class="flex items-center gap-2 rounded px-4 py-2 bg-surface-overlay text-color shadow-md">
        <i class="pi pi-exclamation-circle"></i>
        <span>Use Shift+Scroll to zoom in</span>
      </div>
    </div>
  }
</div>
